import { Box } from "@material-ui/core";
import clsx from "clsx";
import React, { useMemo, useState } from "react";
import EmailComponent from "../../Containers/Landing/EmailComponent";
import { useStyles } from "../../Containers/Landing/style";
import { CcButton, CcDatePicker } from "../../design-system/carecentre";

const TIME_SLOTS = [
  "1:00 PM - 2:00 PM",
  "2:00 PM - 3:00 PM",
  "4:00 PM - 5:00 PM",
];

const tomorrow = () => {
  const d = new Date();
  d.setDate(d.getDate() + 1);
  d.setHours(0, 0, 0, 0);
  return d;
};

const DemoStep = ({ setStep, classes }) => (
  <Box className={classes.demoCard}>
    <p className={classes.demoHint}>
      Pick a time that works for your team. We’ll send a calendar invite once
      you confirm your details.
    </p>
    <CcButton
      variant="primary"
      className={classes.demoCta}
      onClick={() => setStep(2)}
    >
      Book a demo
    </CcButton>
  </Box>
);

const ScheduleStep = ({
  setStep,
  date,
  onDateChange,
  slot,
  setSlot,
  classes,
  hideStart,
  onCancel,
}) => {
  const minDate = useMemo(() => tomorrow(), []);

  return (
    <Box className={classes.stepBody}>
      <div>
        <h2 className={classes.sectionTitle}>Choose a time</h2>
        <p className={classes.sectionSub}>
          Date and a one-hour window for your demo.
        </p>
      </div>

      <Box className={classes.fieldStack}>
        <CcDatePicker
          label="Date"
          value={date}
          minDate={minDate}
          onChange={(next) => {
            if (next) onDateChange(new Date(next));
          }}
          format="dd MMM yyyy"
          clearable={false}
        />

        <div>
          <p className={classes.sectionLabel}>Time</p>
          <Box className={classes.slotWrap}>
            {TIME_SLOTS.map((ele) => (
              <button
                type="button"
                key={ele}
                className={clsx(classes.slotCard, {
                  [classes.selected]: ele === slot,
                })}
                onClick={() => setSlot(ele)}
                aria-pressed={ele === slot}
              >
                {ele}
              </button>
            ))}
          </Box>
        </div>
      </Box>

      <Box className={classes.formActions}>
        <button
          type="button"
          className={classes.backLink}
          onClick={() => {
            if (hideStart && onCancel) {
              onCancel();
              return;
            }
            setStep(1);
          }}
        >
          Back
        </button>
        <CcButton variant="primary" size="sm" onClick={() => setStep(3)}>
          Continue
        </CcButton>
      </Box>
    </Box>
  );
};

const BookDemoFlow = ({
  moduleName,
  initialStep = 1,
  hideStart = false,
  onCancel,
}) => {
  const classes = useStyles();
  const [step, setStep] = useState(hideStart ? 2 : initialStep);
  const [date, onDateChange] = useState(tomorrow);
  const [slot, setSlot] = useState(TIME_SLOTS[0]);

  if (step === 1) {
    return <DemoStep setStep={setStep} classes={classes} />;
  }

  if (step === 2) {
    return (
      <ScheduleStep
        setStep={setStep}
        date={date}
        onDateChange={onDateChange}
        slot={slot}
        setSlot={setSlot}
        classes={classes}
        hideStart={hideStart}
        onCancel={onCancel}
      />
    );
  }

  return (
    <EmailComponent
      date={date}
      slot={slot}
      setStep={setStep}
      onDateChange={onDateChange}
      setSlot={setSlot}
      moduleName={moduleName}
      defaultSlot={TIME_SLOTS[0]}
      resetDate={tomorrow}
    />
  );
};

export default BookDemoFlow;
